export default __webpack_public_path__ + "b4757fd04483d3eb14b226daccf282db.png";